export default () => {
    if(document.body.classList.contains('single-product')){
        document.cookie = "category_referrer="+document.referrer;
    }
};
 